
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/migrate-courses",
      function () {
        return require("private-next-pages/solutions/migrate-courses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/migrate-courses"])
      });
    }
  